import React, { Component } from 'react';
import s from './index.module.scss'
import { http } from "../../../common/request";
import { Input, Form, Button, message, Spin } from 'antd'
import i18next from 'i18next'

const { TextArea } = Input

class HelpFeedback extends Component {
  feedback_form = React.createRef()
  constructor(props) {
    super(props);
    this.state = {
      requesting: false,
      feedback: {
        content: '',
        contact: ''
      }
    };
  }

  componentDidMount () {

  }

  async submit(values) {

    this.setState({
      requesting: true
    })
    // console.log(values, 'values of submit')
    const params = {
      content: values.content,
      contact: values.contact
    }
    const res = await http('get', '/account/feedback', params).catch(err => {

      message.warn('系统错误')
      this.setState({
        requesting: false
      })

    })
    if (res.data && res.data.code === 0) {

      this.setState({
        requesting: false
      })
      message.success('反馈成功')
      setTimeout(() => {
        // window.location.reload()
      }, 100)

    }
  }


  render () {
    const { feedback, requesting } = this.state
    return (
      <div>
        {
          requesting ? <Spin />
          : <div>
            <div className={s.title}>{i18next.t('feedback')}</div>

            <div >{i18next.t('issueTip')}</div>
            {/* <Form ref={this.feedback_form} style={{marginTop: 20, width: 500}} name='feedback' onFinish={values => {this.submit(values)}} initialValues={feedback}>

              <div className={s.formTitle}>{i18next.t('help')}</div>
              <Form.Item name='content' rules={[
                {
                  required: true,
                  message: '请输入反馈内容'
                }
              ]}>
                <TextArea  rows={1} />
              </Form.Item>

              <div className={s.formTitle}>{i18next.t('contact')}</div>
              <Form.Item name='contact'>
                <Input />
              </Form.Item>

              <Form.Item style={{marginTop: 30}}>
                <Button style={{width: 83}} type='primary' htmlType='submit'>{i18next.t('submit')}</Button>
              </Form.Item>

            </Form> */}
          </div>
        }

      </div>
    );
  }
}

export default HelpFeedback;

